export default __webpack_public_path__ + "img/hamburger-menu.svg";